const STORAGE_KEY = 'talkytimesTranslationSettings';

export const TRANSLATION_PROVIDER_YOUDAO = 'youdao';
export const TRANSLATION_PROVIDER_LLM = 'llm';

export const TRANSLATION_PROVIDERS = [
  { id: TRANSLATION_PROVIDER_YOUDAO, name: '有道翻译' },
  { id: TRANSLATION_PROVIDER_LLM, name: '大模型' },
];

let backendAiModel = process.env.VUE_APP_LM_STUDIO_MODEL || '';

export function setBackendAiModel(model) {
  backendAiModel = model ? String(model).trim() : '';
}

export function getBackendAiModel() {
  return backendAiModel;
}

function getDefaultSettings() {
  return {
    provider: TRANSLATION_PROVIDER_YOUDAO,
    model: backendAiModel,
  };
}

export function getTranslationSettings() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        provider: parsed.provider || TRANSLATION_PROVIDER_YOUDAO,
        model: parsed.model || backendAiModel,
      };
    }
  } catch (error) {
    console.error('读取翻译设置失败:', error);
  }
  return { ...getDefaultSettings() };
}

export function setTranslationSettings(partial) {
  const next = { ...getTranslationSettings(), ...partial };
  if (!next.model) {
    next.model = backendAiModel;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function getTranslationOptions() {
  const settings = getTranslationSettings();
  return {
    provider: settings.provider,
    model: settings.model || getBackendAiModel(),
  };
}
